export const ENVIRONMENT_TYPE = {
  LOCAL: "local",
  DEV: "development",
  PRODUCTION: "production",
  STAGING: "staging",
  TEST: "test",
};